import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import MarqueeStrip from "../components/MarqueeStrip";
import About from "../components/About";
import Works from "../components/Works";
import Experience from "../components/Experience";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function Home() {
  const location = useLocation();
  const [meta, setMeta] = useState(null);
  const [marquees, setMarquees] = useState({ top: null, bottom: null });

  useEffect(() => {
    Promise.all([api.get("/hero").catch(() => null), api.get("/footer").catch(() => null), api.get("/about").catch(() => null)])
      .then(([h, f, a]) => {
        const hero = h?.data || {};
        const footer = f?.data || {};
        const about = a?.data || {};
        const title = `${footer.studio_name || "Studio/Kai"}® — ${[hero.line1, hero.accent1, hero.line2, hero.accent2].filter(Boolean).join(" ")}`;
        const desc = hero.paragraph || footer.blurb || "Independent designer & developer portfolio.";
        const image = about.portrait_url || undefined;
        setMeta({ title, desc, image, siteName: footer.studio_name || "Studio/Kai" });
      });
    api.get("/marquees").then((r) => setMarquees(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <SmoothScroll>
      {meta && <SEO title={meta.title} description={meta.desc} image={meta.image} siteName={meta.siteName} />}
      <div className="grain bg-[#F4F4F0] text-[#0A0A0A] min-h-screen" data-testid="home-page">
        <Toaster position="bottom-right" />
        <Navbar />
        <main>
          <Hero />
          {marquees.top?.items?.length > 0 && (
            <MarqueeStrip
              items={marquees.top.items}
              italic={marquees.top.italic}
              outline={marquees.top.outline}
              speed={marquees.top.speed || 50}
            />
          )}
          <About />
          <Works />
          {marquees.bottom?.items?.length > 0 && (
            <MarqueeStrip
              items={marquees.bottom.items}
              italic={marquees.bottom.italic}
              outline={marquees.bottom.outline}
              speed={marquees.bottom.speed || 30}
            />
          )}
          <Services />
          <Experience />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
